import React from 'react';
import { useNavigate } from 'react-router-dom';
import PartnerDashboardBusinessCard from '../components/PartnerDashboardBusinessCard';
import PartnerEmptyState from '../components/PartnerEmptyState';
import { portalCopy } from '../copy';
import { usePartnerAuth } from '../context/PartnerAuthContext';
import { usePartnerBusiness } from '../context/PartnerBusinessContext';
import { partnerWizardPath } from '../partnerPaths';

const PartnerDashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = usePartnerAuth();
  const { business } = usePartnerBusiness();

  if (!user) return null;

  if (!business) {
    return (
      <div>
        <h1 className="font-instrument text-3xl italic tracking-[-0.01em] text-[#2a0f2a]">
          {portalCopy.dashboard.greeting(user.name)}
        </h1>
        <div className="mt-8">
          <PartnerEmptyState onAddBusiness={() => navigate(partnerWizardPath())} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="font-instrument text-3xl italic tracking-[-0.01em] text-[#2a0f2a]">
        {portalCopy.dashboard.greeting(user.name)}
      </h1>
      <p className="mt-2 font-jakarta text-[15px] text-[#5a3158]">{portalCopy.dashboard.yourBusiness}</p>

      <PartnerDashboardBusinessCard business={business} />
    </div>
  );
};

export default PartnerDashboardPage;
